import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { AuthShell } from '../components/AuthShell'
import {
  PreferenceCategory,
  PreferenceDiv,
  PreferenceScreen,
} from '../components/Preference'
import { QrScanner } from '../components/QrScanner'
import { parseInvitePayload } from '../lib/inviteCode'

/** Scan invite QR — then redirect to /invite/:code (auth there). */
export default function Join() {
  const navigate = useNavigate()
  const [scanKey, setScanKey] = useState(0)

  function onScan(raw: string) {
    const code = parseInvitePayload(raw)
    if (!code) {
      toast.error('Geen geldige uitnodiging herkend. Probeer opnieuw.')
      setScanKey((k) => k + 1)
      return
    }
    navigate(`/invite/${encodeURIComponent(code)}`)
  }

  return (
    <AuthShell>
      <PreferenceScreen title="Scan uitnodiging" backHref="/">
        <PreferenceCategory filled>
          <PreferenceDiv className="overflow-hidden first:rounded-t-2xl last:rounded-b-2xl rounded">
            <QrScanner key={scanKey} onScan={onScan} />
          </PreferenceDiv>
        </PreferenceCategory>
      </PreferenceScreen>
    </AuthShell>
  )
}
